import CryptoJS from 'crypto-js';
import logger from './logger';

// Plan codes that grant SharpStack access: anything containing 'sharpstack' or an '_ss_'/'_ss' token
export const hasSharpStackPlan = (plan) => {
  const p = (plan || '').trim().toLowerCase();
  return p.includes('sharpstack') || /(^|_)ss(_|$)/.test(p);
};
const validateAuthToken = ({ name, timestamp, token, secretKey = '4for4-betting-user' }) => {
  const tokenData = {
    name: name || 'anonymous',
    hour: timestamp,
  };

  let computedToken = CryptoJS.HmacSHA256(
    JSON.stringify(tokenData),
    secretKey
  ).toString(CryptoJS.enc.Base64);

  computedToken = computedToken
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

  return computedToken === token;
};

const isDevEnvironment = () => {
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.includes('.dev') || // For custom dev domains
    hostname.includes('.local') // For local network testing
  );
};

// Function to get query string parameters and validate
export const checkUserAuth = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const name = urlParams.get('name') || 'anonymous';
  const timestamp = urlParams.get('timestamp');
  const token = urlParams.get('token');
  const plan = urlParams.get('plan');
  const isInIframe = window.self !== window.top;
  
  logger.log('Auth check params:', { name, timestamp, token, plan, isInIframe });
      if (!isInIframe && isDevEnvironment()) {
      // For development/testing when not in iframe
      return { isValid: true, name: 'SharpStackUser', reason: 'dev-mode', plan: ''};
    }
  //If no auth params provided, return as unauthenticated guest
  if (!timestamp && !token && !plan) {
    logger.log('No auth parameters provided - guest user');
    return { isValid: false, name: '', reason: 'no-params' };
  }

  // If partial auth params, it's an invalid auth attempt
  if (!name || !timestamp || !token || !plan) {
    logger.log('Missing some auth parameters');

    return { isValid: false, name: null, reason: 'missing-params' };
  }

  // Validate the token
  let isValid = validateAuthToken({
    name,
    timestamp,
    token,
    plan,
    secretKey: '4for4-betting-user',
  });

  //Check if user doesn't have betting plan
if (plan && !hasSharpStackPlan(plan)) {
  logger.log('User does not have betting plan:', plan);
  return { isValid: false, name: name, reason: 'no-betting-plan', plan: plan };
}

  // Additional validation rules
  if (name === 'anonymous') {
    isValid = false;
  }
  return { isValid, name: isValid ? name : null, reason: isValid ? 'success' : 'invalid-token', plan: plan };
};

// Function to force refresh after 24 hours
export const forceRefreshIfExpired = (timestamp) => {
  const currentTime = new Date();
  const timestampDate = new Date(
    parseInt(timestamp.slice(0, 4)), // Year
    parseInt(timestamp.slice(4, 6)) - 1, // Month (0-based)
    parseInt(timestamp.slice(6, 8)), // Day
    parseInt(timestamp.slice(8, 10)) // Hour
  );
  const hoursDiff = (currentTime - timestampDate) / (1000 * 60 * 60);
  if (hoursDiff >= 24) {
    logger.log('Token expired, forcing refresh');
    window.location.reload(); // Or redirect to 4for4 login
  }
};